/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { Provider, APP_INITIALIZER } from '@angular/core';
import { KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

function initializeKeycloak(keycloak: KeycloakService) {
  keycloak.keycloakEvents$.subscribe(event => {
    if (event.type === KeycloakEventType.OnTokenExpired) {
      keycloak.logout();
    }
  });
  return () =>
    keycloak.init({
      config: environment.keycloakConfig,
      initOptions: {
        enableLogging: true,
        checkLoginIframe: false,
        responseMode: 'query',
        onLoad: 'check-sso',
      },
    });
}

function getKeycloakProvider(): Provider {
  return {
    provide: APP_INITIALIZER,
    useFactory: initializeKeycloak,
    multi: true,
    deps: [KeycloakService],
  };
}

export const KeycloakProvider = getKeycloakProvider();
